var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconIdle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.69 15.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #667085;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3.67,7.63c-2.28,1.65-2.87,5.28-2.87,5.28-.15.78.04,1.6.86,1.6h3.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m6.02,7.63c2.28,1.65,2.87,5.28,2.87,5.28.15.78-.04,1.6-.86,1.6h-3.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3.67,7.63C1.39,5.97.8,2.35.8,2.35c-.15-.78.04-1.6.86-1.6h3.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m6.02,7.63c2.28-1.65,2.87-5.28,2.87-5.28.15-.78-.04-1.6-.86-1.6h-3.35"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.69,
    y1: 12.67,
    x2: 6.87,
    y2: 12.67
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIdle);
export default __webpack_public_path__ + "static/media/icon_idle.6a06ef3c0027f34649bf7c8c09b3a5d8.svg";
export { ForwardRef as ReactComponent };